import { TemplateRef } from '@angular/core';
import {
  CellTemplateContext,
  ColumnBuilder,
  crudActions,
  DatasetTableConfig,
  TableConfigBuilder,
  dateColumn,
} from '@ui/lib/ui-kit/ui-dataset-table';
import { EventV2Document } from '@models/alerts-v2.model';
import moment from 'moment-timezone';

export type EntranceCellContext = CellTemplateContext<EventV2Document>;

export interface CreateEntrancesTableConfigDependencies {
  nameCellTemplate: TemplateRef<EntranceCellContext>;
  getCameraName: (row: EventV2Document) => string;
}

export function createEntrancesTableConfig(
  dependencies: CreateEntrancesTableConfigDependencies,
): DatasetTableConfig<EventV2Document> {
  const builder = new ColumnBuilder<EventV2Document>();

  return new TableConfigBuilder<EventV2Document>()
    .columns([
      builder
        .column('name')
        .label('ENTRANCE.TABLE.NAME')
        .width('minmax(200px, 1fr)')
        .cellTemplate(dependencies.nameCellTemplate)
        .mobileVisible()
        .cardBoldValue()
        .build(),

      builder
        .column('_id')
        .label('ENTRANCE.TABLE.CAMERA')
        .width('minmax(150px, 1fr)')
        .formatter((_, row) => dependencies.getCameraName(row))
        .mobileVisible()
        .cardIcon('ui-icon-camera')
        .build(),

      dateColumn<EventV2Document>('createdAt', 'ENTRANCE.TABLE.CREATED_AT', {
        width: 'minmax(200px, 1fr)',
        mobileVisible: true,
        customFormat: 'MMM DD yyyy, hh:mm A',
        timezone: moment.tz.guess(),
        showTimeZone: true,
      }),
    ])
    .actions(crudActions<EventV2Document>())
    .trackBy('_id')
    .build();
}
